import React from 'react';
import { Typography } from '@mui/material';

const RegimenInfo = ({ boardDescription, rate }) => {
  const rooms = rate?.rooms || [];

  const textBaseSx = {
    color: 'black',
    fontSize: { xs: 18, sm: 14, md: 15 },
    lineHeight: 1.5,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  };

  return (
    <>
      <Typography sx={textBaseSx}>
        Régimen: <span style={{ fontWeight: 700 }}>{boardDescription}</span>
      </Typography>
      <Typography sx={textBaseSx}>
        {rooms.length} {rooms.length > 1 ? 'Habitaciones' : 'Habitación'}
      </Typography>
    </>
  );
};

export default RegimenInfo;
